import axios from 'axios';
import { getToken, getApplicationCode } from "./user";
// 引入配置文件
import config from '@/config'
// 引入工具
axios.defaults.withCredentials = false;
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
// api地址
const base = process.env.NODE_ENV === 'production'
	? config.baseUrl.pro
	: config.baseUrl.dev;

//文件预览地址
export const fileViewUrl = process.env.NODE_ENV === 'production'
	? config.fileViewUrl.pro
	: config.fileViewUrl.dev;

export const baseUrl = base;
//定义请求异常事件
let httpErroEvent = new CustomEvent('http_error_event', {
	detail: {
		type: "loginOut"
	}
})
export const getData = (getUrl,params) => {
	return Promise.race([
		new Promise((resolve, reject) => {
			axios.get(base + getUrl, {
				headers: {
					'Authorization': getToken(),
					'Application': getApplicationCode()
				},
				params:params
			})
				.then(async (response) => {
					var clearData = response.data;


					if (clearData.code == 200) {
						resolve({
							state: 1,
							msg: clearData.message,
							data: clearData.data,
							total: clearData.data ? clearData.data.total : 0,
						})
					} else {
						
						if (clearData.code == 401) {
							resolve({
								state: 0,
								msg: '重新登陆'
							})
							//开发环境不退出
							if(process.env.NODE_ENV === 'production'){
								setTimeout(() => {
									window.dispatchEvent(httpErroEvent);
								}, 300);
							}
						}else if(clearData.code == 403){
							resolve({
								state: 0,
								msg: '您没有权限访问此功能'
							})
							
							//开发环境不退出
							if(process.env.NODE_ENV === 'production'){
								setTimeout(() => {
									window.dispatchEvent(httpErroEvent);
								}, 300);
							}

						} else {
							resolve({
								state: 0,
								msg: clearData.message
							})
						}
					}
				})
				.catch((error) => {
					resolve({
						state: 0,
						msg:"网络错误"
					})
				})
		}),
		new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve({
					'state': 0,
					'msg': '请求超时'
				})
			}, 60000)
		})
	])
}

// post
export const postData = (postUrl, param) => {
	return Promise.race([
		new Promise((resolve, reject) => {
			axios.post(base + postUrl, param, {
				headers: {
					'Authorization': getToken(),
					'Application': getApplicationCode()
				},
			})
				.then(async (response) => {
					
					var clearData = response.data;
					if (clearData.code == 200) {
						resolve({
							state: 1,
							msg: clearData.message,
							data: clearData.data,
							total: clearData.data ? clearData.data.total : 0,
						})
					} else {
						
						if (clearData.code == 401) {
							resolve({
								state: 0,
								msg: '重新登陆'
							})
							//开发环境不退出
							if(process.env.NODE_ENV === 'production'){
								setTimeout(() => {
									window.dispatchEvent(httpErroEvent);
								}, 300);
							}
						}else if(clearData.code == 403){
							resolve({
								state: 0,
								msg: '您没有权限访问此功能'
							})
							
							//开发环境不退出
							if(process.env.NODE_ENV === 'production'){
								setTimeout(() => {
									window.dispatchEvent(httpErroEvent);
								}, 300);
							}

						} else {
							resolve({
								state: 0,
								msg: clearData.message
							})
						}
					}
				})
				.catch((error, response) => {
					resolve({
						state: 0,
						msg: error.response ? error.response.data.msg : "网络错误"
					})
				})
		}),
		new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve({
					'state': 0,
					'msg': '请求超时'
				})
			}, 60000)
		})
	])
}
